export default __webpack_public_path__ + "static/media/18.8be56a57.png";